/* tslint:disable */

declare var Object: any;
export interface StandardDiscountInterface {
  "productType": string;
  "merchantType": number;
  "paymentType": number;
  "discount": number;
  "dateCreated"?: Date;
  "lastUpdated"?: Date;
  "id"?: number;
}

export class StandardDiscount implements StandardDiscountInterface {
  "productType": string;
  "merchantType": number;
  "paymentType": number;
  "discount": number;
  "dateCreated": Date;
  "lastUpdated": Date;
  "id": number;
  constructor(data?: StandardDiscountInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StandardDiscount`.
   */
  public static getModelName() {
    return "StandardDiscount";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StandardDiscount for dynamic purposes.
  **/
  public static factory(data: StandardDiscountInterface): StandardDiscount{
    return new StandardDiscount(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StandardDiscount',
      plural: 'StandardDiscounts',
      path: 'StandardDiscounts',
      idName: 'id',
      properties: {
        "productType": {
          name: 'productType',
          type: 'string'
        },
        "merchantType": {
          name: 'merchantType',
          type: 'number'
        },
        "paymentType": {
          name: 'paymentType',
          type: 'number'
        },
        "discount": {
          name: 'discount',
          type: 'number',
          default: 0
        },
        "dateCreated": {
          name: 'dateCreated',
          type: 'Date'
        },
        "lastUpdated": {
          name: 'lastUpdated',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
